import Typography from '../../DataDisplay/Typography/Typography.js';
import React__default, { useState, useEffect, cloneElement } from 'react';

const HandleError = ({ mandatory = false, mandatoryOnStart = false, minLength, maxLength, mandatoryError, minError, maxError, children, }) => {
    const [error, setError] = useState(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (event) => {
        const value = event.target.value;
        if (mandatory && value.length < 1) {
            setError(mandatoryError || `Field is mandatory.`);
        }
        else if (minLength && value.length < minLength) {
            setError(minError || `Value must be at least ${minLength} characters.`);
        }
        else if (maxLength && value.length > maxLength) {
            setError(maxError || `Value must be no more than ${maxLength} characters.`);
        }
        else {
            setError(null);
        }
        if (children.props.onChange) {
            children.props.onChange(event);
        }
    };
    useEffect(() => {
        setError(null);
    }, [mandatory, mandatoryOnStart, minLength, maxLength]);
    // Use effect on Mount only if mandatory && mandatoryOnStart
    useEffect(() => {
        if (mandatory && mandatoryOnStart) {
            const value = children.props.value;
            if (value === undefined ||
                value === null ||
                (typeof value === 'string' && value.length < 1) ||
                (Array.isArray(value) && value.length < 1)) {
                setError(mandatoryError || `Field is mandatory.`);
            }
        }
    }, [mandatory, mandatoryOnStart, mandatoryError, children.props.value]);
    const childWithProps = cloneElement(children, {
        className: error ? 'form-input-error' : '', //add class to child if error
        onChange: handleChange,
    });
    return (React__default.createElement(React__default.Fragment, null,
        childWithProps,
        error && (React__default.createElement("div", { className: "form-error-message" },
            React__default.createElement(Typography, { tag: "textsmall" }, error)))));
};

export { HandleError as default };
//# sourceMappingURL=HandleError.js.map
